"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Link_1 = __importDefault(require("shared/components/Link"));
var Policies = function () { return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ px: 8, mx: 4, pt: 2 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1, align: "center" }, { children: "Our Policies" })), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ display: "flex", justifyContent: "space-between", p: 8, mx: 8 }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 2 }, { children: (0, jsx_runtime_1.jsx)(Link_1.default, __assign({ to: "/policies/privacy-policy" }, { children: "Privacy Policy" })) })), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 2 }, { children: (0, jsx_runtime_1.jsx)(Link_1.default, __assign({ to: "/policies/terms-and-conditions" }, { children: "Terms and Conditions" })) }))] }))] }))); };
exports.default = Policies;
